import { AggregatedQuantityDTO } from "../dto/AggregatedQuantityDTO";
import { AggregatedQuantity } from "@domain/sales/models/AggregatedQuantity";

export class AggregatedQuantityMapper {
    static toModel(dto: AggregatedQuantityDTO): AggregatedQuantity {
        return {
            year: dto.year,
            week: dto.week,
            quantity: dto.quantity,
            forecastQuantity: dto.forecastQuantity,
        };
    }
}